module.exports = __webpack_public_path__ + "static/media/mobileScreenshot09.24eeeda0.jpg";